export class SubscribeToLicensesRequest {
    VerboseUpdates: boolean;
    LicenseKeys: Array<string>;
}
